import React from 'react';
import { Loading, ComposedModal, ModalHeader, ModalBody, ModalFooter, Button } from 'carbon-components-react';


export function ConfirmAlertCustom(props) {
    let id = props.idToDelete;
    if (id == null) return null;
    //RITM0954296 
    let nameItem = props.nameItem;
    let loading = props.isDeleting;
    return (<ComposedModal
        className="light-modal confirm-modal"
        open={props.open}
        onClose={props.onCloseConfirm}
    >
        <ModalHeader className="margin-modal" title={props.msgDeleteConfirm || 'Are you sure to delete?'} /> 
        <ModalBody>
            {loading && <Loading active={true} withOverlay={true} description="Deleting" />}
            <p>{nameItem}</p>
            {props.children}
        </ModalBody>

        <ModalFooter >
            <Button kind="secondary" onClick={props.onCloseConfirm}>
                {props.msgDeleteNo|| "NO"}  
            </Button>
            <Button kind='primary' onClick={() => props.deleteItem()}>
                {props.msgDeleteYes || "YES"}
            </Button>
        </ModalFooter>
    </ComposedModal>
    );
};
